export default {
  SET_COINS(state, payload) {
    state.coins = payload
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  RESET_STORE(state) {
    state.coins = []
    state.loading = false
  },
}
